import { IonSpinner } from '@ionic/react';
import { useTreeStore } from '../stateManagement/treeZustand';
import { useGlobalStore } from '../stateManagement/globalZustand';
import { label2LabelToShow } from '../../foo/cards';
import { useEffect, useState } from 'react';
import { getArasaacImages } from '../foo';
import { _SPACE_CARD } from '../constants';
import CardZero from '../CardZero';
import { fetchImagesWithFallback } from '../../foo/retrieval';
import { CellProps } from './Cell';


function CellCard(props: CellProps) {
  //const [image, setImage] = useState<string>("");
  const [spinnerIfNoImage, setSpinnerIfNoImage] = useState<boolean>(false);
  const { l2Image, setL2Image, getImage, l2Color, setL2Color} = useTreeStore();

  


  const { lang } = useGlobalStore();
  //const labelToShow = label2LabelToShow(props.label, lang, capitalizeText);

  /*// This useEffect is only triggered if image is fetched, i.e. not locally available
  useEffect(() => {
    if (image !== "") {
      const newL2Image = { ...l2Image };
      newL2Image[props.label] = image;
      setL2Image(newL2Image);
    }
  }, [image]);  */

  useEffect(() => {
    const fetchData = async () => {
      
      // If image is passed externally, don't fetch it
      if (props.image && props.image.length > 0) return;
      // If an image is found locally, don't fetch it
      if (getImage(props.label).length > 0) return;
      // Otherwise, set loading spinner and fetch image
      setSpinnerIfNoImage(true);
      const images = await fetchImagesWithFallback(lang, props.label, 1, "ARASAAC", false, false)

      if (images !== null && images.length > 0 && images[0] !== null && images[0] !== undefined) {
        // Update the cells using props.updateCell
        props.updateCell(props.index, { image: images[0] });
      };
    setSpinnerIfNoImage(false);
  }

    fetchData();
    
  }, []);



  
  

  return <CardZero
  label={props.label}
  image={props.image}
  icons={[]}
  isBorderBlack={!props.isSelected}
  isBorderHighlighted={props.isSelected}
  spinnerIfNoImage={spinnerIfNoImage}
  backgroundColor={props.color}  />
    
    
}

export default CellCard;
